import Req from '../../$axios';

const serviceModule = {
  // 员工列表
  getStaffIndex(params) {
    return Req({
      url: 'users/userIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 新增员工
  saveStaff(params) {
    return Req({
      url: 'users/save',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 员工详情
  getStaffDetail(params) {
    return Req({
      url: 'users/read',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  //更新员工
  updateStaff(params) {
    return Req({
      url: 'users/update',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 删除员工
  deleteStaffr(params) {
    return Req({
      url: 'users/delete',
      method: 'delete',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  getNumberOfEmployees(params) {//获取在职总人数
    return Req({
      url: 'users/getNumberOfEmployees',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },

  // 离职人员未完成任务查询
  getResignUserTasks(params) {
    return Req({
      url: 'project/getResignUserUnfinishTaskOfTheProjectList',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 办理离职
  userResign(params) {
    return Req({
      url: 'users/resign',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 离职人员任务交接
  resignHandoverTasks(params) {
    return Req({
      url: 'tasks/resignHandoverTasks',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  }
};

export default {
  ...serviceModule
};
